export const financeMonths = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

export const emptyInstallment = () => ({
  dueDate: "",
  scheduledSendAt: "",
  boleto: null
});

export const createEmptyChargeForm = () => ({
  competenceMonth: "",
  competenceYear: String(new Date().getFullYear()),
  amount: "",
  recurring: false,
  recurrenceCount: 1,
  installments: [emptyInstallment()]
});

export const competenceForOffset = (year, month, offset = 0) => {
  const date = new Date(Number(year), Number(month) - 1 + offset, 1);
  const resultYear = date.getFullYear();
  const resultMonth = String(date.getMonth() + 1).padStart(2, "0");
  return `${resultYear}-${resultMonth}-01`;
};

export const competenceLabel = competence => {
  const [year, month] = competence.split("-");
  return `${financeMonths[Number(month) - 1]} / ${year}`;
};

export const resizeInstallments = (installments, count) =>
  Array.from({ length: count }, (_, index) => installments[index] || emptyInstallment());

